module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAWCAYAAABHcFUAAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADWSURBVEhL7ZTBDcMgDEW7JYNYYg0GYRAGYRAXozSltimOqhQOPMkHJ5F5fCIe3ntcrarUSmwpK/dIpYAupKN5k4JD5bFgIJUwQMR8dFcggVaMeoi2SeOkaNdVLGOEspDr1CGfI+jv2xrENZYq0EJyDkkC8s3zb6n/SKhztC0mKZ2+lJpOW79Incel/lczk8oR4aKUSIbXDKm/JpVCKJfEC12KI6QMmKUiu3ekFPXsmL5VmdnDJlWGyN3OTKr8A+3QelM3ux0td4/UBLaUlS1l5ZRaqzw+AflnRzillYgBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/order_hover.png
// module id = 1251
// module chunks = 0